import type { DataTableColumn } from '@/components/custom/erp';
import type { CoQuanThue } from '@/types/schemas';

export const getDataTableColumns = (): DataTableColumn<CoQuanThue>[] => [
  { field: 'ma_cqt', headerName: 'Mã cơ quan thuế', width: 300 },
  { field: 'ten_cqt', headerName: 'Tên cơ quan thuế', width: 300 },
  { field: 'created', headerName: 'Ngày tạo', width: 300 }
];

export const taxSearchColumns: DataTableColumn<CoQuanThue>[] = [
  { field: 'ma_cqt', headerName: 'Mã cơ quan thuế', flex: 1 },
  { field: 'ten_cqt', headerName: 'Tên cơ quan thuế', flex: 1 }
];
